import React, { useState, useEffect } from 'react'
import ServiceLocator from 'live/services/service-locator'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'

type ExtraActionsInjectedProps = {
    renderSeparator: boolean
    afterActionExecute: (...any) => void
}

const ExtraActionsInjected: React.FC<ExtraActionsInjectedProps> = ({
    renderSeparator,
    afterActionExecute
}: ExtraActionsInjectedProps) => {
    const [actionsRegistry, setActionsRegistry] = useState(null)
    const [openDropdown, setOpenDropdown] = useState<boolean>(false)

    useEffect(() => {
        ServiceLocator.getService('purge-extra-actions-registry').then(setActionsRegistry)
    }, [])

    return actionsRegistry ? (
        <actionsRegistry.Consumer>
            {actions => (
                <>
                    {actions.length > 0 && renderSeparator && <VerticalLine />}

                    {actions.length > 0 && (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <LiveTooltip position="top" content={i18n('Additional actions available')}>
                                <Dropdown onClick={() => setOpenDropdown(!openDropdown)}>
                                    <i className={`far fa-solid ${openDropdown ? 'fa-caret-up' : 'fa-caret-down'}`} />
                                </Dropdown>
                            </LiveTooltip>
                            {openDropdown && (
                                <ExtraActionsWrapper>
                                    {actions.map((actionEntry, index) => {

                                        return (
                                            <ExtraButton
                                                key={index}
                                                onClick={async () => {
                                                    let success = false
                                                    let message = ''
                                                    try {
                                                        await actionEntry.callback()
                                                        success = true
                                                        message = actionEntry.successMessage
                                                    } catch (e) {
                                                        success = false
                                                        message = actionEntry.errorMessage
                                                    }

                                                    afterActionExecute(success, message)
                                                    setOpenDropdown(false)
                                                }}
                                            >
                                                <i className={`far fa-regular ${actionEntry.icon}`}></i>
                                                {actionEntry?.label}
                                            </ExtraButton>
                                        )
                                    })}
                                </ExtraActionsWrapper>
                            )}
                        </div>
                    )}
                </>
            )}
        </actionsRegistry.Consumer>
    ) : null
}

const VerticalLine = styled.div`
    border-left: 1px solid var(--gray-400);
    margin: 0 10px;
`

const ExtraActionsWrapper = styled.div`
    z-index: 1;
    position: absolute;
    margin-top: 42px;
    background-color: var(--gray-100);
    padding: 10px;
    display: grid;
    gap: 7px;
    max-height: 155px;
    overflow: auto;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: var(--gray-600);
        border-radius: 0;
        background-clip: padding-box;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 0;
        margin: 1px;
    }
`

const Dropdown = styled.button`
    background: var(--gray-200);
    color: var(--blue-700);
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 3px;
    font-size: 16px;
`

const ExtraButton = styled.button`
    background: var(--blue-700);
    color: var(--white);

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 24px;
    gap: 8px;

    height: 40px;

    border: none;
    border-radius: 3px;
    font-size: 16px;
    font-weight: 600;

    flex: none;
    order: 0;
    flex-grow: 0;
`

export default ExtraActionsInjected
